import { type ProductOrBanner, ProductOrBannerType } from '../type/banner';

import {
  filterBannersByPlacementAndSortByPriority,
  getFirstBannerPlacementInProductList,
  getSecondBannerPlacementInProductList,
} from './bannerPlacement';

import type { Banner } from '../effect/schema/openapi/backend';
import { BannerPlacementType } from '../enum/bannerPlacement';

/**
 * Inserts category listing banners into a product cards array at configured
 * positions. Generic over the product shape: every product is passed
 * through untouched, so the caller's own type carries here unchanged.
 */
export function insertBannersIntoProducts<TProduct>(
  products: readonly TProduct[],
  banners: readonly Banner[],
  columnCount: number
): ProductOrBanner<TProduct>[] {
  // Wrap products in discriminated union format
  const result: ProductOrBanner<TProduct>[] = products.map((product) => ({
    type: ProductOrBannerType.Product,
    product,
  }));

  const banners1 = filterBannersByPlacementAndSortByPriority(
    banners,
    BannerPlacementType.CATEGORY_LISTING_1
  );
  const banners2 = filterBannersByPlacementAndSortByPriority(
    banners,
    BannerPlacementType.CATEGORY_LISTING_2
  );

  const banner2Placement = getSecondBannerPlacementInProductList(columnCount);
  if (banners2.length > 0 && result.length >= banner2Placement) {
    result.splice(banner2Placement, 0, {
      type: ProductOrBannerType.Banner,
      banners: banners2,
    });
  }

  const banner1Placement = getFirstBannerPlacementInProductList(columnCount);
  if (banners1.length > 0 && result.length >= banner1Placement) {
    result.splice(banner1Placement, 0, {
      type: ProductOrBannerType.Banner,
      banners: banners1,
    });
  }

  return result;
}
